import {
  GoogleAuthProvider, createUserWithEmailAndPassword, onAuthStateChanged,
  sendPasswordResetEmail, signInWithEmailAndPassword, signInWithPopup,
  signOut, updateProfile,
} from 'firebase/auth';
import { auth } from '../config/firebase';
import { syncUserProfile } from './userProfileService';

export const subscribeToAuth = (callback) => onAuthStateChanged(auth, callback);
export const signInWithGoogle = () => signInWithPopup(auth, new GoogleAuthProvider());
export const signInWithEmail = (email, password) => signInWithEmailAndPassword(auth, email.trim(), password);
export async function registerWithEmail(name, email, password) {
  const result = await createUserWithEmailAndPassword(auth, email.trim(), password);
  await updateProfile(result.user, { displayName: name.trim() });
  // Profile sync is retried by the application; an already-created account stays usable.
  await syncUserProfile().catch(() => {});
  return result;
}
export const resetPassword = (email) => sendPasswordResetEmail(auth, email.trim());
export const logOut = () => signOut(auth);

export function authErrorMessage(error) {
  const messages = {
    'auth/invalid-credential': 'The email or password is incorrect.',
    'auth/email-already-in-use': 'An account already exists with this email. Try signing in.',
    'auth/weak-password': 'Choose a password with at least 8 characters.',
    'auth/popup-closed-by-user': 'The Google sign-in window was closed. Please try again.',
    'auth/popup-blocked': 'Allow pop-ups for this site to continue with Google.',
    'auth/unauthorized-domain': 'Add this site to Firebase Authentication’s authorized domains.',
    'auth/operation-not-allowed': 'Enable Google and Email/Password sign-in in Firebase Authentication.',
    'auth/network-request-failed': 'Could not connect. Check your internet connection.',
    'auth/too-many-requests': 'Too many attempts. Please try again later.',
  };
  return messages[error.code] || error.message || 'Something went wrong. Please try again.';
}
